var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "126", height: "113", viewBox: "0 0 126 113", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M121.115.2L1.775 53.71a2.97 2.97 0 0 0-1.516 3.93 3.035 3.035 0 0 0 1.887 1.62l40.382 12.11 11.31 39.41a3.081 3.081 0 0 0 2.268 2.08h.582c.893 0 1.736-.37 2.308-1.04l22.49-26.88 39.76 15.82c.341.16.712.25 1.084.25 1.665 0 3.02-1.34 3.02-3.01V2.95A3.01 3.01 0 0 0 122.28 0c-.392.01-.763.09-1.125.24l-.04-.04zM11.529 55.88l92.165-41.37-60.202 50.93-31.963-9.56zm46.504 47.84l-9.845-34.35L98.455 27 60.752 72.37a2.96 2.96 0 0 0 .382 4.18c.24.2.512.37.792.5l14.12 5.59-18.013 21.08zm61.326-10.06L67.577 73.04l51.782-62.07v82.69z", fill: "#0061AC" })
  );
});